import Base from './base';
import Input from '../../design-system/input';
import {
  EMAIL_SUBSCRIPTION_TAG_NAME,
  EMAIL_SUBSCRIPTION_SAMPLE_CLASS
} from '../../classnames/blog';

import {
  SUBSCRIBE_EMAIL_TITLE,
  SUBSCRIBE_EMAIL_DESCRIPTION
} from '../../classnames/email-subscription';

import EmailSubscriptionHandler from '../../shared/email-subscription-handler';

export default class EmailSubscription extends Base {
  titleAttribute = 'title';
  descriptionAttribute = 'description';
  tagName = EMAIL_SUBSCRIPTION_TAG_NAME;
  sample = document.querySelector(`.${EMAIL_SUBSCRIPTION_SAMPLE_CLASS}`);
  input = new Input();

  buildNode = (placeholder) => {
    const newNode = this.sample.cloneNode(true);

    newNode.classList.remove(EMAIL_SUBSCRIPTION_SAMPLE_CLASS);

    this.initializeNodeText(newNode, placeholder);
    this.initializeNodeEvents(newNode);

    return newNode;
  };

  initializeNodeText = (node, placeholder) => {
    const title = placeholder.getAttribute(this.titleAttribute);
    const description = placeholder.getAttribute(this.descriptionAttribute);

    node.querySelector(`.${SUBSCRIBE_EMAIL_TITLE}`).innerHTML = title;
    node.querySelector(`.${SUBSCRIBE_EMAIL_DESCRIPTION}`).innerHTML = description;
  };

  initializeNodeEvents = (node) => {
    const emailHandler = new EmailSubscriptionHandler(node);
    const { form } = emailHandler;

    emailHandler.initialize();
    this.input.initializeEventListeners(form);
  };
}
